import * as React from 'react';
import { useSelector } from 'react-redux';
import { EHelpTextPosition, IQuestionLayoutProps } from '@cian/frontend-request-form-widget';

import { selectIsRegistered, selectPrice } from '../../selectors/legalCheck';
import { CustomQuestionLayout } from '../../components/CustomQuestionLayout';
import { getSubtitle } from './utils';
import { IRequestFormQuestion } from '../../types/requestForm';

export const PaymentStepContainer: React.FC<IQuestionLayoutProps<IRequestFormQuestion>> = props => {
  const { question, ...rest } = props;

  const isRegistered = useSelector(selectIsRegistered);

  const price = useSelector(selectPrice);
  const overrideQuestion = React.useMemo(
    () => ({
      ...question,
      helpText: { position: EHelpTextPosition.Above, text: getSubtitle(price, isRegistered) },
    }),
    [question, price, isRegistered],
  );

  return <CustomQuestionLayout question={overrideQuestion} {...rest} />;
};

PaymentStepContainer.displayName = 'PaymentStepContainer';
